// Scholarship guidelines.
//
// Ported from app/views/scholarship/guidelines.haml. The year was interpolated there from
// ApplicationController::YEAR, a constant edited by hand each August; here it comes from the
// current cycle, so it cannot go stale.

import { Link } from 'react-router-dom';
import { useSession } from '../App.tsx';
import { Loading, formatDate, formatAward } from '../components/Bits.tsx';

export function Guidelines() {
  const { data, isPending } = useSession();
  if (isPending) return <main id="main"><Loading /></main>;

  const year = data?.cycle?.year ?? new Date().getUTCFullYear() + 1;
  const closes = data?.cycle?.closesAt;

  return (
    <main id="main">
      <p><Link to="/">← Back</Link></p>
      <h2>Scholarship guidelines</h2>

      <div className="panel">
        <dl className="dl">
          <dt>Scholarship name</dt>
          <dd>2027 SEED Foundation Scholarship</dd>

          <dt>Amount of award</dt>
          <dd>
            {data?.cycle
              ? `${formatAward(data.cycle.awardAmount, data.cycle.awardYears)}, divided equally`
              : '—'}
          </dd>

          <dt>Deadline</dt>
          <dd>
            {closes ? formatDate(closes) : `April 30, ${year}`}, no later than 11pm Eastern,
            through this website.
            <br />
            <em>No exceptions or extensions will be granted.</em>
          </dd>
        </dl>
      </div>

      <h3>Who can apply</h3>
      <div className="panel">
        <ul>
          <li>Of Asian-Indian heritage, with at least one parent of Indian ancestry</li>
          <li>A graduating U.S. high school senior (Class of {year})</li>
          <li>A minimum GPA of 3.0 on a 4.0 scale</li>
          <li>
            Enrolling as a full-time undergraduate at a U.S. university in the Fall of {year}
          </li>
          <li>A legal resident of the United States</li>
          <li>
            <strong>
              The scholarship must be applied to tuition only. Room, board and other college
              expenses cannot be covered.
            </strong>
          </li>
        </ul>
        <p className="hint">
          Financial need is not an eligibility requirement, but applicants with need — shown by
          adjusted gross income, or by the number of family members in college at the same
          time — are given special consideration.
        </p>
      </div>

      <h3>Questions</h3>
      <div className="panel">
        <p style={{ marginTop: 0 }}>
          Nupur Gupta<br />
          SEED Foundation Scholarship Program<br />
          2500 Independence Ave<br />
          Glenview, IL 60026<br />
          <a href="mailto:scholarship@seedfoundation.org">scholarship@seedfoundation.org</a>
        </p>
      </div>

      <div className="notice info">
        <strong>Important.</strong> Any late or incomplete application makes the applicant
        ineligible. Recipients are notified in early summer {year}, and winners are listed on
        the foundation's website.
      </div>

      <div className="actions">
        <Link to="/"><button>Back to the application</button></Link>
        <button className="secondary" onClick={() => window.print()}>Print this page</button>
      </div>
    </main>
  );
}
